import { apiClient } from '@/shared/lib/api-client';
import type {
  NotificationPreferences,
  UpsertWebPushSubscriptionDto,
  UpdateNotificationPreferencesDto,
  UpdateNotificationTimezoneDto,
  WebPushSubscriptionState,
} from '@bookclub/shared';

export async function fetchNotificationPreferences(): Promise<NotificationPreferences> {
  return apiClient.get('notifications/preferences').json<NotificationPreferences>();
}

export async function updateNotificationPreferences(
  updates: UpdateNotificationPreferencesDto,
): Promise<NotificationPreferences> {
  return apiClient
    .patch('notifications/preferences', { json: updates })
    .json<NotificationPreferences>();
}

export async function updateNotificationTimezone(
  input: UpdateNotificationTimezoneDto,
): Promise<NotificationPreferences> {
  return apiClient.patch('notifications/timezone', { json: input }).json<NotificationPreferences>();
}

export async function upsertWebPushSubscription(
  input: UpsertWebPushSubscriptionDto,
): Promise<WebPushSubscriptionState> {
  return apiClient
    .put('notifications/web-push/subscription', { json: input })
    .json<WebPushSubscriptionState>();
}

export async function deleteWebPushSubscription(endpoint?: string): Promise<WebPushSubscriptionState> {
  return apiClient
    .delete('notifications/web-push/subscription', { json: endpoint ? { endpoint } : {} })
    .json<WebPushSubscriptionState>();
}
